import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useToken from '../context/useToken';
import axios from 'axios';
import { BASE_URL } from '../utils';

const Banner = () => {
    const token = useToken()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bannerData,setBannerData] = useState({});
  const [formData, setFormData] = useState({
    img: bannerData.img,
    title: bannerData.title,
    description: bannerData.description,
  });

  
  const fetchBannerData = async () => {
    try {
      const initialResponse = await axios.get(`${BASE_URL}hero-banner?page=1`);
      const totalPages = initialResponse.data.totalPages; // Assuming the API provides this
  
      // Fetch the last page
      const lastPageResponse = await axios.get(`${BASE_URL}hero-banner?page=${totalPages}`);
      const banners = lastPageResponse.data.heroBanners;
  
      // Retrieve the last banner from the last page
      const banner = banners[banners.length - 1];
      setBannerData({
        img: banner.background_image,
        title: banner.heading,
        description: banner.subtitle,
      });
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  };

  // Call fetchBannerData when component mounts
  useEffect(() => {
    fetchBannerData();
  }, [token]);

  
  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        img: file, // Update the state with the new image URL
      }));
    }
  };

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    setBannerData(formData); // Update the bannerData with current formData
    setIsModalOpen(false); // Close the modal

    // Prepare formData for POST request
    const data = new FormData();
    data.append('heading', formData.title);
    data.append('subtitle', formData.description);
    data.append('cta', "");
    data.append('cta_link', "");
    data.append('cta_color', "");
    data.append('isActive', true);

    if (formData.img) {
      data.append('image', formData.img, formData.img);
    }

    try {
      const response = await axios.post(`${BASE_URL}hero-banner`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          'accept': '*/*',
        },
      });
      fetchBannerData()
      console.log('Banner saved successfully:', response.data);
    } catch (error) {
      console.error('Error saving banner:', error);
    }
  };

  return (
    <div>
      <div
        className="relative md:h-[109vh] h-[70vh] bg-cover bg-center z-1"
        style={{ backgroundImage: `url(${bannerData.img})` }}
      >
        <div className="absolute inset-0 bg-[#03000c] opacity-75"></div>

        <div className="absolute z-1 flex flex-col items-start justify-center min-h-full w-[70%] px-4 mt-6 sm:px-10 md:px-16">
          <div className="text-white text-left px-4 py-6 w-full max-w-3xl mx-auto">
            <h1 className="text-[40px] sm:text-[50px] md:text-[70px] font-extrabold leading-tight mb-4 animate-fade-in-up">
              {bannerData.title}
            </h1>
            <p className="text-[#c6c9d8] text-lg sm:text-xl md:text-2xl mb-10 max-w-xl sm:max-w-2xl animate-fade-in-up">
              {bannerData.description}
            </p>
            <div className='flex items-center gap-8'>
            <Link to="/contact">
              <button className="bg-[#25a182] border border-[#25a182] mt-4 text-white px-[40px] py-[15px] text-base sm:text-lg font-medium rounded-lg shadow-md transition-transform transform hover:bg-transparent hover:text-[#fff] hover:scale-105 hover:-translate-y-2 duration-300 animate-fade-in-up">
                Contact Us
              </button>
            </Link>
            {token && <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-14 h-14 cursor-pointer mt-2"
              onClick={handleEditClick}
              >
              <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
              <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
            </svg>}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-lg p-6 w-[90%] sm:w-[50%]">
      <h2 className="text-2xl font-bold mb-4">Edit Banner Content</h2>
      
      {/* Image Upload Section */}
      <div className="mb-4">
        <label className="block text-gray-700">Image</label>
        <input
          type="file"
          accept="image/*" // Accept only image files
          onChange={handleImageChange} // Call the new function on file selection
          className="border border-gray-300 p-2 w-full rounded"
        />
      </div>
      
      {/* Title Input */}
      <div className="mb-4">
        <label className="block text-gray-700">Title</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="border border-gray-300 p-2 w-full rounded"
        />
      </div>
      
      {/* Description Input */}
      <div className="mb-4">
        <label className="block text-gray-700">Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="border border-gray-300 p-2 w-full rounded h-28"
        />
      </div>

      {/* Buttons */}
      <div className="flex justify-end">
        <button
          onClick={() => setIsModalOpen(false)}
          className="bg-red-500 text-white px-4 py-2 rounded mr-4"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="bg-[#25a182] text-white px-4 py-2 rounded"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default Banner;
